import { useEffect } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { SourceKey, ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
import { useFastshiftSelector } from '@/state';

import { calculateEngagementMetrics } from '../utils';

export const useMigrationsManagementPageAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
	const { fireScreenEvent, fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

	const {
		data: engagementData,
		error: engagementError,
		pending: engagementPending,
	} = useFastshiftSelector((state) => state.customerDomainEngagement);

	// Screen event
	useEffect(() => {
		if (!identityAttrs) return;
		fireScreenEvent({
			name: SourceKey.FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
		});
	}, [fireScreenEvent, identityAttrs]);

	// Track event
	useEffect(() => {
		if (!identityAttrs || engagementPending) {
			return;
		}

		const hasError = !!engagementError;
		const metrics =
			!hasError && engagementData
				? calculateEngagementMetrics(engagementData)
				: {
						embedCount: null,
						boardCount: null,
						projectCount: null,
						spaceCount: null,
					};

		fireTrackEvent({
			action: ActionKey.DISPLAYED,
			actionSubject: ActionSubjectKey.SECTION,
			actionSubjectId: ActionSubjectIdKey.MIGRATION_PLANNER_EMBED_SECTION,
			source: sourceKey,
			attributes: {
				hasError,
				errorType: engagementError,
				...metrics,
			},
		});
	}, [
		fireTrackEvent,
		identityAttrs,
		engagementData,
		engagementError,
		engagementPending,
		sourceKey,
	]);
};
